import { Stack } from "@mui/material";
import React, { useEffect } from "react";

import { useLocation } from "react-router-dom";
import CertificateCard from "../CertificateCard/CertificateCard";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import CommentSection from "./CommentSection/CommentSection";

const BlogPageSection = () => {
  // Scroll to the top on reload
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);
  const location = useLocation();
  const card = location.state;
  return (
    <>
      <Header />
      <main>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: "60px",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid red",
              width: { xl: "68%" },
              height: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Stack>
              <h1>Blog Id: {card.postId || "Blog Id  not  found"}</h1>
              <h1>Title: {card.postTitle || "title not  found"}</h1>
              <p>Category: {card.category || "category not found"}</p>
              <p>
                Description: {card.postDescription || "Description not found"}
              </p>
             
              postDescription
              <img
                src={card.postImage || "Image not found"}
                alt={card.postId || "title not found"}
                style={{ height: "100px", width: "100px" }}
              />
             
            </Stack> */}
            <Stack
              sx={{
                // marginTop: "60px",
                // border: "2px solid green",
                height: "auto",
              }}
            >
              {/* <h1>Content Source Code</h1> */}
              {/* Render the postHtmlSourceCode as HTML */}
              <div
                dangerouslySetInnerHTML={{
                  __html: card?.postHtmlSourceCode || "<p>No content found</p>",
                }}
                style={{
                  // border: "1px solid #ddd",
                  // padding: "20px",
                  // background: "#f9f9f9",
                  // borderRadius: "10px",
                }}
              ></div>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CommentSection />
      <CertificateCard />
      <Footer />
    </>
  );
};

export default BlogPageSection;

// import { Stack } from "@mui/material";
// import React, { useEffect } from "react";
// import Header from "../../Header/Header";
// import Footer from "../../Footer/Footer";
// import { useLocation } from "react-router-dom";
// import CertificateCard from "../CertificateCard/CertificateCard";

// const BlogPageSection = () => {
//   // Scroll to the top on reload
//   useEffect(() => {
//     window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
//     if (window.location.hash) {
//       // Remove any hash in the URL
//       window.history.replaceState(null, null, " ");
//     }
//   }, []);
//   const location = useLocation();
//   const card = location.state;
//   return (
//     <>
//       <Header />

//       <main>
//         <Stack
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "center",
//           }}
//         >
//           <Stack
//             sx={{
//               // border: "1px solid red",
//               width: { xl: "68%" },
//               height: "auto",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             {/* <Stack>
//               <h1>Blog Id: {card.postId || "Blog Id  not  found"}</h1>
//               <h1>Title: {card.postTitle || "title not  found"}</h1>
//               <p>Category: {card.category || "category not found"}</p>
//               <p>
//                 Description: {card.postDescription || "Description not found"}
//               </p>

//               postDescription
//               <img
//                 src={card.postImage || "Image not found"}
//                 alt={card.postId || "title not found"}
//                 style={{ height: "100px", width: "100px" }}
//               />

//             </Stack> */}
//             <Stack
//               sx={{
//                 // marginTop: "60px",
//                 // border: "2px solid green",
//                 height: "auto",
//               }}
//             >
//               {/* <h1>Content Source Code</h1> */}
//               {/* Render the postHtmlSourceCode as HTML */}
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: card?.postHtmlSourceCode || "<p>No content found</p>",
//                 }}
//                 style={{
//                   border: "1px solid #ddd",
//                   padding: "20px",
//                   background: "#f9f9f9",
//                   borderRadius: "10px",
//                 }}
//               ></div>
//             </Stack>
//           </Stack>
//         </Stack>
//       </main>
//       <CertificateCard />
//       <Footer />
//     </>
//   );
// };

// export default BlogPageSection;
